<template>
  <v-chip :color="color" outlined class="px-4" ripple>
    {{ value }}
  </v-chip>
</template>

<script>
export default {
  name: "folderCount",
  props: ["item", "config"],
  computed: {
    entry() {
      const counts = (this.config && this.config.counts) || {};
      const id = String(this.item.id || this.item._id);
      return counts[id] || { total: 0, overdue: 0, costs: 0 };
    },
    kind() {
      return (this.config && this.config.kind) || "total";
    },
    value() {
      if (this.kind === "overdue") return this.entry.overdue || 0;
      if (this.kind === "costs") {
        return (this.entry.costs || 0).toLocaleString("de-DE", {
          style: "currency",
          currency: "EUR",
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        });
      }
      return this.entry.total || 0;
    },
    color() {
      if (this.kind === "overdue") return "red";
      if (this.kind === "costs") return "blue-grey";
      return "primary";
    },
  },
};
</script>
